/**
 * @generated SignedSource<<a3a63cc2ffa5f993d23a5f84cc5dd866>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type CompleteTransactionMutation$variables = {
  token: string;
};
export type CompleteTransactionMutation$data = {
  readonly unified: {
    readonly linking: {
      readonly completeTransaction: {
        readonly errors: ReadonlyArray<{
          readonly code: string | null;
          readonly extensions: {
            readonly errorType: string | null;
            readonly statusCode: number | null;
          } | null;
          readonly message: string | null;
        }> | null;
        readonly message: string | null;
        readonly success: boolean;
      } | null;
    } | null;
  } | null;
};
export type CompleteTransactionMutation = {
  response: CompleteTransactionMutation$data;
  variables: CompleteTransactionMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "token"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "message",
  "storageKey": null
},
v2 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "UnifiedMutation",
    "kind": "LinkedField",
    "name": "unified",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "UnifiedLinkingMutation",
        "kind": "LinkedField",
        "name": "linking",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": [
              {
                "kind": "Variable",
                "name": "token",
                "variableName": "token"
              }
            ],
            "concreteType": "UnifiedLinkingStatusPayload",
            "kind": "LinkedField",
            "name": "completeTransaction",
            "plural": false,
            "selections": [
              (v1/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "success",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "UnifiedMutationError",
                "kind": "LinkedField",
                "name": "errors",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "UnifiedMutationErrorExtension",
                    "kind": "LinkedField",
                    "name": "extensions",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "errorType",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "statusCode",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "code",
                    "storageKey": null
                  },
                  (v1/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "CompleteTransactionMutation",
    "selections": (v2/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "CompleteTransactionMutation",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "23b7dabc47bc666cb7fb10fd0dd1db04",
    "id": null,
    "metadata": {},
    "name": "CompleteTransactionMutation",
    "operationKind": "mutation",
    "text": "mutation CompleteTransactionMutation(\n  $token: String!\n) {\n  unified {\n    linking {\n      completeTransaction(token: $token) {\n        message\n        success\n        errors {\n          extensions {\n            errorType\n            statusCode\n          }\n          code\n          message\n        }\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "260c1ef61c851f3e9e8e8c7daf03704b";

export default node;
